// Page-specific tutorials and homepage category interactions.
(function(){function initialize(){

 // Reserve the same image space while waiting for the CDN image to decode.
 document.querySelectorAll('main.vna-howto-page .vhu-image-shell').forEach(shell=>{
  if(shell.dataset.mediaBound)return;shell.dataset.mediaBound='true';
  const img=shell.querySelector('img'),retry=shell.querySelector('[data-vhu-image-retry]');
  if(!img)return;
  function state(value){shell.dataset.mediaState=value;shell.setAttribute('aria-busy',String(value==='loading'))}
  function ready(){const decoded=img.decode?img.decode():Promise.resolve();decoded.catch(()=>{}).then(()=>state(img.naturalWidth>0?'ready':'error'))}
  img.addEventListener('load',ready);img.addEventListener('error',()=>state('error'));
  if(retry)retry.addEventListener('click',()=>{state('loading');img.loading='eager';img.src=img.getAttribute('src')});
  if(img.complete){if(img.naturalWidth>0)ready();else state('error')}
 });


(function(){
 const root=document.getElementById('vna-howto-20261012');if(!root||root.dataset.ready)return;
 const text=(en,ja)=>root.dataset.locale==='ja'?ja:en;
 const mobile=matchMedia('(max-width:767px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
 const host=root.querySelector('#vhu-tutorials'),rail=root.querySelector('.vhu-categories'),cats=[...root.querySelectorAll('[data-vhu-category]')],groups=[...root.querySelectorAll('[data-vhu-group]')];
 const dialog=root.querySelector('.vhu-dialog'),drawerScroll=root.querySelector('.vhu-drawer-scroll'),drawerTitle=root.querySelector('#vhu-drawer-title'),closeButton=root.querySelector('.vhu-drawer-close');
 let activeKey='airlight',trigger=null,closing=false,closeTimer=0,scrollFrame=0,bodySnapshot=null;
 const sliders=[];
 const guides=root.querySelector('[data-vhu-guides]'),guideAnchor=root.querySelector('[data-vhu-guide-anchor]');
 let desktopAnimation=null,desktopOpen=true,desktopKey=activeKey;
 // Native touch scrolling, mouse dragging, wheel easing and progress follow the homepage vna-category-slider.
 function makeSlider(track,fill,prev,next){
  let frame=0,wheelFrame=0,target=0,pointerId=null,startX=0,startScroll=0,dragging=false,suppress=false,touchX=0,touchY=0;
  function update(){frame=0;const max=Math.max(0,track.scrollWidth-track.clientWidth),scroll=Math.max(0,Math.min(max,track.scrollLeft));if(fill)fill.style.transform='scaleX('+Math.min(1,(scroll+track.clientWidth)/Math.max(1,track.scrollWidth))+')';if(prev)prev.disabled=scroll<=2;if(next)next.disabled=scroll>=max-2}
  function refresh(){if(!frame)frame=requestAnimationFrame(update)}
  function stop(){if(wheelFrame)cancelAnimationFrame(wheelFrame);wheelFrame=0;target=track.scrollLeft}
  function ease(){const distance=target-track.scrollLeft;if(Math.abs(distance)<=2){track.scrollLeft=target;wheelFrame=0;return}track.scrollLeft+=distance*.24;wheelFrame=requestAnimationFrame(ease)}
  function byCard(direction){stop();const first=track.firstElementChild,gap=parseFloat(getComputedStyle(track).columnGap)||0;track.scrollBy({left:direction*((first?first.offsetWidth:track.clientWidth)+gap),behavior:reduced.matches?'auto':'smooth'})}
  if(prev)prev.addEventListener('click',()=>byCard(-1));if(next)next.addEventListener('click',()=>byCard(1));
  track.addEventListener('scroll',refresh,{passive:true});
  track.addEventListener('pointerdown',e=>{if(e.pointerType!=='mouse'||e.button!==0||mobile.matches)return;pointerId=e.pointerId;startX=e.clientX;startScroll=track.scrollLeft;dragging=false;stop()});
  track.addEventListener('pointermove',e=>{if(e.pointerId!==pointerId)return;const distance=e.clientX-startX;if(!dragging){if(Math.abs(distance)<8)return;dragging=true;track.classList.add('is-dragging');track.setPointerCapture(e.pointerId)}track.scrollLeft=startScroll-distance;e.preventDefault()});
  function end(e){if(e.pointerId!==pointerId)return;pointerId=null;track.classList.remove('is-dragging');if(track.hasPointerCapture(e.pointerId))track.releasePointerCapture(e.pointerId);if(dragging){suppress=true;setTimeout(()=>suppress=false,0)}dragging=false}
  track.addEventListener('pointerup',end);track.addEventListener('pointercancel',end);track.addEventListener('dragstart',e=>e.preventDefault());
  track.addEventListener('click',e=>{if(suppress){e.preventDefault();e.stopPropagation();suppress=false}},{capture:true});
  track.addEventListener('touchstart',e=>{if(e.touches.length!==1)return;touchX=e.touches[0].clientX;touchY=e.touches[0].clientY},{passive:true});
  track.addEventListener('touchend',e=>{if(!e.changedTouches.length)return;const dx=Math.abs(e.changedTouches[0].clientX-touchX),dy=Math.abs(e.changedTouches[0].clientY-touchY);if(dx>4&&dx>dy){suppress=true;setTimeout(()=>suppress=false,400)}},{passive:true});
  if(track!==rail)track.addEventListener('wheel',e=>{if(e.ctrlKey)return;let distance=Math.abs(e.deltaX)>Math.abs(e.deltaY)?e.deltaX:e.deltaY;if(e.deltaMode===1)distance*=20;if(e.deltaMode===2)distance*=track.clientWidth;distance=Math.max(-120,Math.min(120,distance));const max=track.scrollWidth-track.clientWidth;if(!distance||max<=1||(distance>0?track.scrollLeft>=max-1:track.scrollLeft<=1))return;e.preventDefault();if(!wheelFrame)target=track.scrollLeft;const pending=Math.max(-480,Math.min(480,target-track.scrollLeft+distance));target=Math.max(0,Math.min(max,track.scrollLeft+pending));if(reduced.matches){track.scrollLeft=target;return}if(!wheelFrame)wheelFrame=requestAnimationFrame(ease)},{passive:false});
  if(track.classList.contains('vhu-steps'))track.addEventListener('keydown',e=>{if(e.target!==track||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();if(e.key==='Home'||e.key==='End'){stop();track.scrollTo({left:e.key==='Home'?0:track.scrollWidth,behavior:reduced.matches?'auto':'smooth'})}else byCard(e.key==='ArrowLeft'?-1:1)});
  if(window.ResizeObserver)new ResizeObserver(refresh).observe(track);update();sliders.push(refresh);
 }
 makeSlider(rail,root.querySelector('.vhu-scroll-line span'),root.querySelector('[data-vhu-scroll="-1"]'),root.querySelector('[data-vhu-scroll="1"]'));
 root.querySelectorAll('.vhu-step-slider').forEach(s=>makeSlider(s.querySelector('.vhu-steps'),s.querySelector('.vhu-step-progress span'),s.querySelector('[data-vhu-step-prev]'),s.querySelector('[data-vhu-step-next]')));
 function pauseAll(){root.querySelectorAll('video').forEach(v=>v.pause())}
 function visiblePanel(){return root.querySelector('[data-vhu-group="'+activeKey+'"] [data-vhu-panel]:not([hidden])')}
 function syncTitle(){const panel=visiblePanel(),group=groups.find(g=>g.dataset.vhuGroup===activeKey);drawerTitle.textContent=panel?panel.querySelector('h2').textContent:group.getAttribute('aria-label')}
 function refresh(){sliders.forEach(f=>f());requestScroll();syncTitle();requestAnimationFrame(syncVisibleMedia)}
 function isActive(v){return (mobile.matches||!host.inert)&&v.offsetWidth>0&&(!mobile.matches||dialog.open)&&!document.hidden}
 function requestPlay(v){if(!isActive(v)||!v.paused||v.dataset.userPaused==='true'||reduced.matches)return;const promise=v.play();if(promise)promise.catch(()=>{})}
 function loadVideo(v,retry=false){if(retry||!v.getAttribute('src')){v.muted=true;v.preload='metadata';v.src=v.dataset.src;v.load()}}
 function syncVisibleMedia(){root.querySelectorAll('video').forEach(v=>{if(!isActive(v)){v.pause();return}loadVideo(v);const r=v.getBoundingClientRect();if(r.bottom>0&&r.top<innerHeight)requestPlay(v);else v.pause()})}
 const playIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4l14 8-14 8z"/></svg>',pauseIcon='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h5v16H5zM14 4h5v16h-5z"/></svg>';
 root.querySelectorAll('.vhu-video-shell').forEach(shell=>{
  const v=shell.querySelector('video'),button=shell.querySelector('[data-vhu-play]'),sound=shell.querySelector('[data-vhu-sound]'),native=shell.querySelector('[data-vhu-native]'),status=shell.querySelector('.vhu-media-status');
  const retry=shell.querySelector('[data-vhu-video-retry]');
  function mediaState(value){shell.dataset.mediaState=value;shell.setAttribute('aria-busy',String(value==='loading'));if(retry)retry.hidden=value!=='error'}
  ['loadstart','emptied'].forEach(event=>v.addEventListener(event,()=>mediaState('loading')));
  v.addEventListener('waiting',()=>{if(v.readyState<3)mediaState('loading')});
  v.addEventListener('stalled',()=>{if(v.readyState<2&&!v.error)mediaState('loading')});
  ['loadeddata','canplay','playing'].forEach(event=>v.addEventListener(event,()=>mediaState('ready')));
  v.addEventListener('pause',()=>{if(v.readyState>=2&&!v.error)mediaState('ready')});
  v.addEventListener('error',()=>mediaState('error'));
  if(retry)retry.addEventListener('click',()=>{mediaState('loading');status.hidden=true;v.dataset.userPaused='false';loadVideo(v,true);v.play().catch(()=>{if(!v.error){status.hidden=false;status.textContent=text('Use the video controls to start playback.','動画コントロールから再生してください。')}})});
  mediaState(v.error?'error':v.readyState>=2?'ready':'loading');

  function update(){button.innerHTML=v.paused?playIcon:pauseIcon;button.setAttribute('aria-label',v.paused?text('Play tutorial video','使い方動画を再生'):text('Pause tutorial video','使い方動画を一時停止'));button.setAttribute('aria-pressed',String(!v.paused));sound.setAttribute('aria-label',v.muted?text('Turn sound on','音声をオンにする'):text('Mute sound','音声をオフにする'));sound.innerHTML=v.muted?'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9h4l5-4v14l-5-4H3zM16 8l5 7-2 1-5-7z"/></svg>':'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9h4l5-4v14l-5-4H3zM16 6l2-1c5 5 5 9 0 14l-2-1c4-4 4-8 0-12z"/></svg>'; sound.setAttribute('aria-pressed',String(!v.muted))}
  button.addEventListener('click',()=>{if(v.paused){loadVideo(v);v.dataset.userPaused='false';v.play().catch(()=>{status.hidden=false;status.textContent=text('Use the video controls to start playback.','動画コントロールから再生してください。')})}else{v.dataset.userPaused='true';v.pause()}});
  sound.addEventListener('click',()=>{v.muted=!v.muted;update()});
  native.addEventListener('click',()=>{v.controls=!v.controls;native.setAttribute('aria-pressed',String(v.controls));native.textContent=v.controls?text('Hide controls','コントロールを隠す'):text('Video controls','動画コントロール');shell.classList.toggle('has-native-controls',v.controls)});
  v.addEventListener('play',update);v.addEventListener('pause',update);v.addEventListener('loadeddata',()=>{status.hidden=true;update();syncVisibleMedia()});v.addEventListener('error',()=>{status.hidden=false;status.textContent=text('Video could not load. Please try again.','動画を読み込めませんでした。もう一度お試しください。');update()});update();
 });
 function updateScroll(){scrollFrame=0;if(mobile.matches)return;root.querySelectorAll('.vhu-video-stage').forEach(stage=>{if(!stage.offsetWidth)return;const top=stage.getBoundingClientRect().top,start=innerHeight*.65,end=72,p=reduced.matches?1:Math.max(0,Math.min(1,(start-top)/(start-end)));stage.style.setProperty('--vhu-video-inset',(p*Math.min(64,innerWidth*.033))+'px');stage.style.setProperty('--vhu-video-radius',(p*20)+'px')});syncVisibleMedia()}
 function requestScroll(){if(!scrollFrame)scrollFrame=requestAnimationFrame(updateScroll)}
 window.addEventListener('scroll',requestScroll,{passive:true});window.addEventListener('resize',refresh,{passive:true});drawerScroll.addEventListener('scroll',syncVisibleMedia,{passive:true});document.addEventListener('visibilitychange',syncVisibleMedia);
 function setCategory(key){activeKey=key;pauseAll();groups.forEach(g=>g.hidden=g.dataset.vhuGroup!==key);cats.forEach(b=>b.setAttribute('aria-expanded',String(b.dataset.vhuCategory===key)));refresh()}

 // Keep the outgoing content until the closing motion ends. Capture the current
 // animated height before a rapid reversal, then restore natural sizing at rest.
 function finishDesktop(){
  if(desktopAnimation){desktopAnimation.cancel();desktopAnimation=null}
  host.style.height='';host.style.overflow='';host.style.opacity='';
  if(!mobile.matches){host.hidden=!desktopOpen;host.inert=!desktopOpen;groups.forEach(g=>g.hidden=!desktopOpen||g.dataset.vhuGroup!==desktopKey)}
 }
 function animateDesktop(key){
  const from=host.hidden?0:host.getBoundingClientRect().height,opacity=host.hidden?0:parseFloat(getComputedStyle(host).opacity);
  if(desktopAnimation){desktopAnimation.cancel();desktopAnimation=null}
  desktopOpen=key!==null;if(key!==null)desktopKey=key;
  host.hidden=false;host.inert=!desktopOpen;host.style.height='';host.style.overflow='';host.style.opacity='';
  pauseAll();
  if(desktopOpen)setCategory(key);else cats.forEach(c=>c.setAttribute('aria-expanded','false'));
  const to=desktopOpen?host.getBoundingClientRect().height:0;
  if(reduced.matches||!host.animate){finishDesktop();refresh();return}
  host.style.height=from+'px';host.style.overflow='hidden';
  const animation=host.animate([{height:from+'px',opacity:opacity},{height:to+'px',opacity:desktopOpen?1:0}],{duration:420,easing:'cubic-bezier(.25,.8,.25,1)',fill:'both'});
  desktopAnimation=animation;
  animation.onfinish=()=>{if(desktopAnimation!==animation)return;finishDesktop();refresh()};
 }
 window.addEventListener('resize',()=>{if(desktopAnimation)finishDesktop()},{passive:true});
 reduced.addEventListener('change',()=>{if(desktopAnimation)finishDesktop()});
 function lockBody(){const s=document.body.style;bodySnapshot={position:s.position,top:s.top,left:s.left,right:s.right,width:s.width,overflow:s.overflow,y:window.scrollY};s.position='fixed';s.top=-bodySnapshot.y+'px';s.left='0';s.right='0';s.width='100%';s.overflow='hidden'}
 function unlockBody(){if(!bodySnapshot)return;const s=document.body.style,b=bodySnapshot;['position','top','left','right','width','overflow'].forEach(k=>s[k]=b[k]);bodySnapshot=null;window.scrollTo(0,b.y)}
 function openDrawer(key,b){if(closing){clearTimeout(closeTimer);finishClose(false)}trigger=b;setCategory(key);const g=groups.find(g=>g.dataset.vhuGroup===key);drawerScroll.replaceChildren(g,guides);drawerScroll.scrollTop=0;lockBody();dialog.showModal();requestAnimationFrame(()=>{dialog.classList.add('is-open');closeButton.focus({preventScroll:true});refresh()})}
 function finishClose(returnFocus){clearTimeout(closeTimer);closing=false;dialog.classList.remove('is-open');if(dialog.open)dialog.close();guideAnchor.after(guides);while(drawerScroll.firstChild)host.appendChild(drawerScroll.firstChild);unlockBody();if(mobile.matches)cats.forEach(b=>b.setAttribute('aria-expanded','false'));if(returnFocus&&trigger&&trigger.isConnected)trigger.focus({preventScroll:true});refresh()}
 function closeDrawer(){if(!dialog.open||closing)return;closing=true;pauseAll();dialog.classList.remove('is-open');closeTimer=setTimeout(()=>finishClose(true),reduced.matches?0:320)}
 dialog.addEventListener('keydown',e=>{if(e.key!=='Tab')return;const items=[...dialog.querySelectorAll('button,a[href],input,select,textarea,video[controls],[tabindex]')].filter(el=>el.tabIndex>=0&&!el.disabled&&el.getClientRects().length&&!el.closest('[hidden]'));if(!items.length){e.preventDefault();closeButton.focus();return}const first=items[0],last=items[items.length-1],active=document.activeElement;if(e.shiftKey&&(active===first||!items.includes(active))){e.preventDefault();last.focus()}else if(!e.shiftKey&&(active===last||!items.includes(active))){e.preventDefault();first.focus()}});
 dialog.addEventListener('transitionend',e=>{if(e.target===dialog&&dialog.open&&!closing)syncVisibleMedia()});closeButton.addEventListener('click',closeDrawer);dialog.addEventListener('cancel',e=>{e.preventDefault();closeDrawer()});dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientY<r.top||e.clientY>r.bottom)closeDrawer()}});
 cats.forEach(b=>b.addEventListener('click',()=>{const key=b.dataset.vhuCategory;if(mobile.matches){openDrawer(key,b);return}animateDesktop(b.getAttribute('aria-expanded')==='true'?null:key);rail.scrollTo({left:rail.scrollLeft+b.getBoundingClientRect().left-rail.getBoundingClientRect().left,behavior:reduced.matches?'auto':'smooth'})}));
 groups.forEach(group=>{const tabs=[...group.querySelectorAll('[role=tab]')];function select(t){if(desktopAnimation)finishDesktop();pauseAll();tabs.forEach(b=>{const on=b===t;b.setAttribute('aria-selected',String(on));b.tabIndex=on?0:-1});group.querySelectorAll('[data-vhu-panel]').forEach(p=>p.hidden=p.dataset.vhuPanel!==t.dataset.vhuProduct);refresh()}
 tabs.forEach((t,index)=>{t.addEventListener('click',()=>select(t));t.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(index+1)%tabs.length;else if(e.key==='ArrowLeft')n=(index+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();select(tabs[n]);tabs[n].focus({preventScroll:true});tabs[n].scrollIntoView({block:'nearest',inline:'nearest'})})})});
 function layout(){finishDesktop();host.inert=false;if(dialog.open||closing)finishClose(false);host.hidden=mobile.matches;if(mobile.matches){pauseAll();cats.forEach(b=>b.setAttribute('aria-expanded','false'))}else{desktopOpen=true;desktopKey=activeKey;setCategory(activeKey)}refresh()}
 mobile.addEventListener('change',layout);reduced.addEventListener('change',refresh);layout();root.dataset.ready='true';
})();


  (() => {
    const root = document.getElementById('vna-category-slider-vhu-shop-categories-20261012');
    if (!root || root.dataset.howtoReady) return;root.dataset.howtoReady = 'true';

    const track = root.querySelector('.vna-category-slider__track');
    const fill = root.querySelector('.vna-category-slider__progress-bar');
    const previous = root.querySelector('.vna-category-slider__arrow--previous');
    const next = root.querySelector('.vna-category-slider__arrow--next');
    if (!track || !fill) return;

    const controller = new AbortController();
    let frame = 0;
    let wheelFrame = 0;
    let wheelTarget = 0;
    let isPointerDragging = false;
    let pointerMoved = false;
    let suppressClick = false;
    let activePointerId = null;
    let pointerStartX = 0;
    let pointerStartScroll = 0;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchStartedAt = 0;

    function updateProgress() {
      frame = 0;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const scroll = Math.max(0, Math.min(maxScroll, track.scrollLeft));
      const ratio = track.scrollWidth > 1
        ? Math.min(1, (scroll + track.clientWidth) / track.scrollWidth)
        : 1;
      fill.style.transform = `scaleX(${ratio})`;
      root.classList.toggle('is-scrollable', maxScroll > 1);
    }

    function requestProgressUpdate() {
      if (frame) return;
      frame = requestAnimationFrame(updateProgress);
    }

    function scrollByCard(direction) {
      stopWheelAnimation();
      const firstCard = track.querySelector('.vna-category-slider__slot');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const distance = (firstCard ? firstCard.offsetWidth : track.clientWidth) + gap;
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: direction * distance, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    function stopWheelAnimation() {
      if (wheelFrame) cancelAnimationFrame(wheelFrame);
      wheelFrame = 0;
      wheelTarget = track.scrollLeft;
    }

    function animateWheelScroll() {
      const remaining = wheelTarget - track.scrollLeft;
      if (Math.abs(remaining) <= 2) {
        track.scrollLeft = wheelTarget;
        wheelFrame = 0;
        return;
      }

      track.scrollLeft += remaining * 0.24;
      wheelFrame = requestAnimationFrame(animateWheelScroll);
    }

    function startPointerDrag(event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || window.innerWidth < 750) return;
      activePointerId = event.pointerId;
      isPointerDragging = false;
      pointerMoved = false;
      pointerStartX = event.clientX;
      pointerStartScroll = track.scrollLeft;
      stopWheelAnimation();
    }

    function movePointerDrag(event) {
      if (activePointerId === null || event.pointerId !== activePointerId) return;
      const distance = event.clientX - pointerStartX;

      if (!isPointerDragging) {
        if (Math.abs(distance) < 8) return;
        isPointerDragging = true;
        pointerMoved = true;
        root.classList.add('is-pointer-dragging');
        track.setPointerCapture(event.pointerId);
      }

      track.scrollLeft = pointerStartScroll - distance;
      event.preventDefault();
    }

    function endPointerDrag(event) {
      if (activePointerId === null || event.pointerId !== activePointerId) return;
      const wasDragging = isPointerDragging;
      activePointerId = null;
      isPointerDragging = false;
      root.classList.remove('is-pointer-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      if (wasDragging && pointerMoved) {
        suppressClick = true;
        window.setTimeout(() => { suppressClick = false; }, 0);
      }
    }

    function scrollWithWheel(event) {
      if (event.ctrlKey) return;
      const primaryDelta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      if (!primaryDelta) return;

      let distance = primaryDelta;
      if (event.deltaMode === 1) distance *= 20;
      if (event.deltaMode === 2) distance *= track.clientWidth;
      distance = Math.max(-120, Math.min(120, distance));

      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const canScroll = distance > 0 ? track.scrollLeft < maxScroll : track.scrollLeft > 0;
      if (!canScroll) return;

      event.preventDefault();

      if (!wheelFrame) wheelTarget = track.scrollLeft;
      const updatedMaxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const maxPendingDistance = Math.min(480, track.clientWidth * 0.65);
      const pendingDistance = Math.max(
        -maxPendingDistance,
        Math.min(maxPendingDistance, wheelTarget - track.scrollLeft + distance)
      );
      wheelTarget = Math.max(0, Math.min(updatedMaxScroll, track.scrollLeft + pendingDistance));

      if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
        track.scrollLeft = wheelTarget;
        return;
      }

      if (!wheelFrame) wheelFrame = requestAnimationFrame(animateWheelScroll);
    }

    function rememberTouchStart(event) {
      if (window.innerWidth >= 750 || event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      touchStartedAt = performance.now();
    }

    function suppressLinkAfterTouchDrag(event) {
      if (window.innerWidth >= 750 || !touchStartedAt || !event.changedTouches.length) return;

      const deltaX = touchStartX - event.changedTouches[0].clientX;
      const deltaY = touchStartY - event.changedTouches[0].clientY;
      const distance = Math.abs(deltaX);
      touchStartedAt = 0;

      if (distance < 4 || distance <= Math.abs(deltaY)) return;
      suppressClick = true;
      window.setTimeout(() => { suppressClick = false; }, 400);
    }

    track.addEventListener('scroll', requestProgressUpdate, {
      passive: true,
      signal: controller.signal
    });
    window.addEventListener('resize', requestProgressUpdate, {
      passive: true,
      signal: controller.signal
    });
    track.addEventListener('pointerdown', startPointerDrag, { signal: controller.signal });
    track.addEventListener('pointermove', movePointerDrag, { signal: controller.signal });
    track.addEventListener('pointerup', endPointerDrag, { signal: controller.signal });
    track.addEventListener('pointercancel', endPointerDrag, { signal: controller.signal });
    track.addEventListener('wheel', scrollWithWheel, { passive: false, signal: controller.signal });
    track.addEventListener('dragstart', (event) => event.preventDefault(), { signal: controller.signal });
    track.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClick = false;
    }, { capture: true, signal: controller.signal });
    track.addEventListener('touchstart', rememberTouchStart, { passive: true, signal: controller.signal });
    track.addEventListener('touchend', suppressLinkAfterTouchDrag, { passive: true, signal: controller.signal });
    track.addEventListener('touchcancel', () => { touchStartedAt = 0; }, {
      passive: true,
      signal: controller.signal
    });
    previous.addEventListener('click', () => scrollByCard(-1), { signal: controller.signal });
    next.addEventListener('click', () => scrollByCard(1), { signal: controller.signal });

    const resizeObserver = window.ResizeObserver ? new ResizeObserver(requestProgressUpdate) : null;
    if (resizeObserver) {
      resizeObserver.observe(track);
      track.querySelectorAll('.vna-category-slider__slot').forEach((slot) => resizeObserver.observe(slot));
    }

    const mutationObserver = new MutationObserver(requestProgressUpdate);
    mutationObserver.observe(track, { childList: true });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target === root || (event.target.contains && event.target.contains(root))) {
        controller.abort();
        if (resizeObserver) resizeObserver.disconnect();
        mutationObserver.disconnect();
        if (frame) cancelAnimationFrame(frame);
        if (wheelFrame) cancelAnimationFrame(wheelFrame);
      }
    }, { signal: controller.signal });

    requestProgressUpdate();
  })();

}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();document.addEventListener('shopify:section:load',initialize);})();
